import { cva } from '@/styled-system/css';

export const toggleButtonIconRecipe = cva({
  base: {
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'color 200ms ease',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {},
    },
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
    selected: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      selected: false,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.icon.default',
          _groupHover: 'ToggleButton.icon.hover',
          _groupActive: 'ToggleButton.icon.pressed',
        },
      },
    },
    {
      selected: false,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.icon.default',
        },
      },
    },
    {
      selected: true,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.icon.selected',
          _groupHover: 'ToggleButton.icon.selectedHover',
          _groupActive: 'ToggleButton.icon.selectedPressed',
        },
      },
    },
    {
      selected: true,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'ToggleButton.icon.selected',
        },
      },
    },
  ],
});
